var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24896B38-C4AE-4E58-BEE9-25A23491C945") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Weboldal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FT1380-&-FT1390-Crimp-Machines---Lomar-header",
    transform: "translate(-1074.000000, -1477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    transform: "translate(1075.000000, 1478.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6 L0,8 C0,11.3137086 2.68629144,14 6,14 L8,14 C11.3137086,14 14,11.3137086 14,8 L14,6 C14,2.68629144 11.3137086,0 8,0 L6,0 C2.68629144,0 0,2.68629144 0,6 Z",
    id: "Vector-61",
    stroke: "#E10210",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7,
    y2: 11,
    id: "Vector-62",
    stroke: "#E10210",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-63",
    transform: "translate(6.000000, 3.000000)",
    fill: "#E10210",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,1.5 C0.72430003,1.5 0.5,1.2757 0.5,1 C0.5,0.72430003 0.72430003,0.5 1,0.5 C1.2757,0.5 1.5,0.72430003 1.5,1 C1.5,1.2757 1.2757,1.5 1,1.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,0 C1.55228,0 2,0.44772006 2,1 C2,1.55228 1.55228,2 1,2 C0.44772006,2 0,1.55228 0,1 C0,0.44772006 0.44772006,0 1,0 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.7e732561ff942be27883a5d1c625f870.svg";
export { ForwardRef as ReactComponent };